// pages/layout/RedirectMCU2025.js
import { useEffect } from "react";

export default function RedirectSurveyHCGA2025() {
  useEffect(() => {
    window.location.href = "https://forms.office.com/r/F3FKHcuDrS";
  }, []);

  return null;
}